import React, { useState, useEffect } from "react";
import '../css/testimoni.css';
import CarouselTesti from "../components/testi";


export default function Testimoni() {
    return (
        <section className="testi">
            <div className="d-flex justify-content-between align-items-start">
                <div>
                    <p className="cerita">Cerita mereka tentang SMA Lab UM</p>
                </div>
                <div>
                    <img src="../../assets/testi/left.png" className="left"></img>
                    <img src="../../assets/testi/arrow-circle-right2.svg" className="right"></img>
                </div>
            </div>
            
            <div className="components" style={{marginTop: "1vh"}}>
               <CarouselTesti /> 
            </div>
            

            {/* UNGU */}
            <div className="ungu d-lg-flex d-md-flex justify-content-center align-items-center" style={{ backgroundColor: "#861FC1", borderRadius: "10px" }}>
                <div className="tiga">
                    <p className="um">PPDB SMA LAB UM</p>
                    <h1 className="masuk">Yuk masuk SMA Lab UM Lur</h1>
                    <button className="daftar">Daftar Sekarang!</button>
                </div>
                <img src="../../assets/ungu.svg" className="men"></img>
            </div>

        </section>
    )
}